// Phase 41 Plan 41-08 — TanStack Query wrapper around the SLA Task timer
// endpoint.
//
// Pattern mirrors `useProjectPackageStatus.ts` (queryKey + enabled-on-id +
// caller-supplied enabled flag). Refetch tuning follows CONTEXT D-4
// "uniform across contexts": short-ish freshness so the bar visibly
// advances while the PM watches a kanban, but not so aggressive that
// open boards hammer the API.
//   - staleTime  30s  — bar accepted as fresh for 30 seconds.
//   - refetchInterval 60s — once per minute the bar may re-paint with
//     newly-accrued elapsed time.
//
// `enabled` is gated TWICE: by `!!taskId` (don't fire on placeholder
// renders) AND by the caller-supplied `enabled` flag, which the
// `SlaTaskCard` wrapper sets to `false` when the task is not in an
// SLA-typed project. That guard prevents 404 noise from non-SLA projects.

import { useQuery } from '@tanstack/react-query';
import {
  fetchSlaTaskTimer,
  type SlaTaskTimerSnapshot,
} from '../services/api/slaTaskTimer';

export type { SlaTaskTimerSnapshot } from '../services/api/slaTaskTimer';

export function useSlaTaskTimer(taskId: number | undefined, enabled = true) {
  return useQuery<{ data: SlaTaskTimerSnapshot }>({
    queryKey: ['slaTaskTimer', taskId],
    queryFn: () => fetchSlaTaskTimer(taskId!),
    enabled: !!taskId && enabled,
    staleTime: 30_000,
    refetchInterval: 60_000,
  });
}
